import React from 'react';
import HeroSectionRo from '../../components/ro/home/HeroSectionRo';
import SynopsisSectionRo from '../../components/ro/home/SynopsisSectionRo';
import TimelineTeaserRo from '../../components/ro/home/TimelineTeaserRo';
import FamiliesTeaserRo from '../../components/ro/home/FamiliesTeaserRo';
import CtaSectionRo from '../../components/ro/home/CtaSectionRo';

const HomePageRo = () => (
  <main>
    <HeroSectionRo />
    <SynopsisSectionRo />
    <TimelineTeaserRo />
    <FamiliesTeaserRo />
    <CtaSectionRo />
  </main>
);

export default HomePageRo;